<template>
  <div>
    <div class="regisInfo">
      <div class="left">
        <div class="title">{{ form.zpqsbt + " - " + form.zpdw }}</div>
      </div>
      <div class="view" @click="showOrHide()">
        {{ detailMessage[showDetails ? 1 : 0] }}
      </div>
      <div class="right">
        <!-- <span @click="print">下载报名表</span> -->
        <span @click="modifyRegisInfo">修改</span>
        <span @click="deleteRegisInfo">删除</span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="right"
      label-width="150px"
      v-show="showDetails"
    >
      <div class="header">
        <div>岗位信息</div>
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="招聘启事">
            <el-input v-model="form.zpqsbt" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="招聘单位">
            <el-input v-model="form.zpdw" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="招聘岗位">
            <el-input v-model="form.gwmc" :disabled="!editing" :readonly="true">
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="openZpgwDialog"
                v-if="editing"
              ></el-button
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-dialog title="招聘岗位查询/选择" :visible.sync="zpgwLov.show">
        <el-form-item label="岗位名称" label-width="100px">
          <el-input v-model="zpgwLov.gwmc" placeholder="请输入">
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="queryZpgw"
            ></el-button>
          </el-input>
        </el-form-item>
        <el-table
          :data="zpgwLov.table"
          style="width: 100%"
          @row-dblclick="tableRowDbclickBackfill"
        >
          <el-table-column prop="zpdw" label="招聘单位"> </el-table-column>
          <el-table-column prop="gwmc" label="岗位名称"> </el-table-column>
          <el-table-column prop="jhrs" label="计划人数"> </el-table-column>
        </el-table>
      </el-dialog>
      <div class="header">
        <div>基本信息</div>
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="身份证号" prop="sfzhm">
            <el-input
              v-model="form.sfzhm"
              placeholder="请输入"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="姓名" prop="xm">
            <el-input
              v-model="form.xm"
              placeholder="请输入"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别" prop="xb">
            <el-select
              v-model="form.xb"
              style="width: 100%"
              :disabled="!editing"
            >
              <el-option
                v-for="item in options.genderList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="出生年月" prop="csrq">
            <el-date-picker
              v-model="form.csrq"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        
        <el-col :span="8">
          <el-form-item label="民族" prop="mz">
            <el-select
              v-model="form.mz"
              style="width: 100%"
              :disabled="!editing"
            >
              <el-option
                v-for="item in options.nationList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :span="8">
          <el-form-item label="政治面貌" prop="zzmm">
            <el-select
              v-model="form.zzmm"
              style="width: 100%"
              :disabled="!editing"
            >
              <el-option
                v-for="item in options.politicsFaceList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="籍贯" prop="jg">
            <el-cascader style="width: 100%;" clearable :options="selectJg" v-model="form.jg" :disabled="!editing"></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="家庭住址" prop="jtzz">
            <el-input
              v-model="form.jtzz"
              placeholder="请输入"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="手机号码" prop="sjhm">
            <el-input
              v-model="form.sjhm"
              placeholder="请输入"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="视力" prop="sl">
            <el-select
              v-model="form.sl"
              style="width: 100%"
              :disabled="!editing"
            >
              <el-option
                v-for="item in options.slList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="身高" prop="sg">
            <el-select
              v-model="form.sg"
              style="width: 100%"
              :disabled="!editing"
            >
              <el-option
                v-for="item in options.sgList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="体重" prop="tz">
            <el-select
              v-model="form.tz"
              style="width: 100%"
              :disabled="!editing"
            >
              <el-option
                v-for="item in options.tzList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="header">
        <div>学习及工作经历</div>
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="最高学历" prop="dyxl">
            <el-select
              v-model="form.dyxl"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            >
              <el-option
                v-for="item in options.educationList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="毕业学校" prop="dyxlbyxx">
            <el-input
              v-model="form.dyxlbyxx"
              placeholder="请输入"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="所学专业" prop="dyxlzy">
            <el-input
              v-model="form.dyxlzy"
              placeholder="请输入"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="毕业时间" prop="dyxlbysj">
            <el-date-picker
              v-model="form.dyxlbysj"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="参加工作时间" prop="cjgzsj">
            <el-date-picker
              v-model="form.cjgzsj"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="现工作单位" prop="xgzdw">
            <el-input
              v-model="form.xgzdw"
              placeholder="请输入"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="现职务或岗位" prop="zwhgw">
            <el-input
              v-model="form.zwhgw"
              placeholder="请输入"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="煤矿井下工作年限" prop="mkjxgznx">
            <el-select
              v-model="form.mkjxgznx"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            >
              <el-option
                v-for="item in options.mkjxgznxList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="相关岗位最高技能等级" prop="xggwzgjndj">
            <el-select
              v-model="form.xggwzgjndj"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            >
              <el-option
                v-for="item in options.xggwzgjndjList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="相关岗位操作资格证" prop="xggwczzgz">
            <el-input
              v-model="form.xggwczzgz"
              placeholder="请输入"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="个人履历" prop="gzpxxxjl">
            <el-input
              type="textarea"
              v-model="form.gzpxxxjl"
              placeholder="xx年至xx年，在xx单位从事xx井下工作"
              maxlength="500"
              show-word-limit
              :disabled="!editing"
            ></el-input>
            <div class="input-tip" v-if="editing">
                注意！输入格式为：xx年至xx年，在xx单位从事xx井下工作
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="header">
        <div>
          其他
        </div>
      </div>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" prop="bz">
            <el-input
              type="textarea"
              v-model="form.bz"
              rows="5"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="header">
        <div>
          附件上传<span style="color: red; margin-left: 5px; font-size: 13px;">（注意：上传格式统一为PDF或JPG，单个上传文件不能超过2M。）</span>
        </div>
      </div>
      <div class="attachments-section">
        <el-row :gutter="10">
        <!-- 身份证上传 -->
        <el-col :span="8">
            <div class="attachment-card">
            <div class="card-header">
                <i class="el-icon-document"></i>
                <span>身份证</span>
                <span class="required">*</span>
            </div>
            <div class="card-body">
                <el-upload
                action=""
                :multiple="false"
                :on-change="sfzUploadChange"
                :auto-upload="false"
                :limit="1"
                accept=".pdf,.jpg,.jpeg,application/pdf,image/jpeg"
                class="upload-demo">
                <el-button size="small" type="primary" v-if="editing">点击上传</el-button>
                </el-upload>
                <div class="file-list">
                <div 
                    v-for="(item, index) in sfzFileSuccessList" 
                    :key="item.uid"
                    class="file-item">
                    <i class="el-icon-document"></i>
                    <span class="file-name">{{ item.raw.name }}</span>
                    <i class="el-icon-delete delete-icon" @click="deleteFile(index,'1')" v-show="editing"></i>
                </div>
                </div>
            </div>
            </div>
        </el-col>
        
        <!-- 毕业证上传 -->
        <el-col :span="8">
            <div class="attachment-card">
            <div class="card-header">
                <i class="el-icon-document"></i>
                <span>毕业证</span>
                <span class="required">*</span>
            </div>
            <div class="card-body">
                <el-upload
                action=""
                :multiple="false"
                :on-change="byzUploadChange"
                :auto-upload="false"
                :limit="5"
                accept=".pdf,.jpg,.jpeg,application/pdf,image/jpeg"
                class="upload-demo">
                <el-button size="small" type="primary" v-if="editing">点击上传</el-button>
                </el-upload>
                <div class="file-list">
                <div 
                    v-for="(item, index) in byzFileSuccessList" 
                    :key="item.uid"
                    class="file-item">
                    <i class="el-icon-document"></i>
                    <span class="file-name">{{ item.raw.name }}</span>
                    <i class="el-icon-delete delete-icon" @click="deleteFile(index,'2')" v-show="editing"></i>
                </div>
                </div>
            </div>
            </div>
        </el-col>
        
        <!-- 技能证书上传 -->
        <el-col :span="8">
            <div class="attachment-card">
            <div class="card-header">
                <i class="el-icon-document"></i>
                <span>应聘岗位相关技能等级证或岗位资格证</span>
                <span class="required">*</span>
            </div>
            <div class="card-body">
                <el-upload
                action=""
                :multiple="false"
                :on-change="gwzgzUploadChange"
                :auto-upload="false"
                :limit="5"
                accept=".pdf,.jpg,.jpeg,application/pdf,image/jpeg"
                class="upload-demo">
                <el-button size="small" type="primary" v-if="editing">点击上传</el-button>
                </el-upload>
                <div class="file-list">
                <div 
                    v-for="(item, index) in gwzgzFileSuccessList" 
                    :key="item.uid"
                    class="file-item">
                    <i class="el-icon-document"></i>
                    <span class="file-name">{{ item.raw.name }}</span>
                    <i class="el-icon-delete delete-icon" @click="deleteFile(index,'3')" v-show="editing"></i>
                </div>
                </div>
            </div>
            </div>
        </el-col>
        </el-row>
      </div> 
      <el-row>
        <el-col :span="2" :offset="22">
          <el-button type="primary" v-show="editing" @click="submitModification"
            >提交修改</el-button
          >
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import share from "@/assets/sharejs/share.js";
import request from "@/api/personCenter.js";
import { provinceAndCityData } from "element-china-area-data";
export default {
  props: {
    formData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      sfzFileSuccessList: [], //身份证附件上传成功列表
      byzFileSuccessList: [], //毕业证附件上传成功列表
      gwzgzFileSuccessList: [], //岗位资格证附件上传成功列表
      fileList: [], //附件上传文件列表
      selectJg: provinceAndCityData,
      zpgwLov: {
        show: false, //是否显示招聘岗位查询/选择模态框
        gwmc: "", //招聘岗位-岗位查询
        table: [], //岗位查询结果
      },
      editing: false, // 是否正在修改编辑
      detailMessage: ["查看报名信息", "收起报名信息"],
      showDetails: false, //显示或收起报名信息
      showResumeMessage: false, //是否显示 添加培训学习简历 文本
      showHomeMemberMessage: false, //是否显示 添加培训学习简历 文本
      cloneForm: {}, //用于复制form，以便修改时，数据复原
      form: {
        zpqsbt: "", //招聘启事标题
        zpqsid: "", //招聘启事id
        zpdw: "", //招聘单位
        gwmc: "", //岗位名称
        gwid: "", //招聘岗位id
        zpbmid: "", //招聘报名id

        sfzhm: "", //身份证号
        xm: "", //姓名
        xb: "", //性别
        mz: "", //民族
        csrq: "", //出生年月
        zzmm: "", //政治面貌
        jg: "", //籍贯
        jtzz: "", //家庭住址
        sjhm: "", //手机号
        sl: "", //视力
        sg: "", //身高
        tz: "", //体重

        dyxl: "", //学历
        dyxlbyxx: "", //毕业学位
        dyxlbysj: "", //第一学历毕业时间
        dyxlzy: "", //第一学历专业
        cjgzsj: "", //参加工作时间
        xgzdw: "", //现工作单位
        zwhgw: "", //现职务或岗位
        mkjxgznx: "", //煤矿井下工作年限
        xggwzgjndj: "", //相关岗位最高技能等级
        xggwczzgz: "", //相关岗位操作资格证
        gzpxxxjl: "", //个人履历
        bz: "", //备注
      },
      rules: {
        sfzhm: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: ["blur", "change"],
          },
        ],
        xm: [
          {
            required: true,
            message: "请输入姓名",
            trigger: ["blur", "change"],
          },
        ],
        xb: [
          {
            required: true,
            message: "请选择性别",
            trigger: ["blur", "change"],
          },
        ],
        csrq: [
          {
            required: true,
            message: "请选择出生日期",
            trigger: ["blur", "change"],
          },
        ],
        mz: [
          {
            required: true,
            message: "请选择民族",
            trigger: ["blur", "change"],
          },
        ],
        zzmm: [
          {
            required: true,
            message: "请选择政治面貌",
            trigger: ["blur", "change"],
          },
        ],
        jg: [
          {
            required: true,
            message: "请选择籍贯",
            trigger: ["blur", "change"]
          }
        ],
        jtzz: [
          {
            required: true,
            message: "请输入家庭住址",
            trigger: ["blur", "change"]
          }
        ],
        sjhm: [
           {
            required: true,
            message: "请输入手机号码",
            trigger: "blur"
          },
          {
            min: 11,
            max: 11,
            message: "手机号码必须为11位",
            trigger: ["blur", "change"],
          },
        ],
        sl: [
          {
            required: true,
            message: "请选择视力",
            trigger: ["blur", "change"],
          },
        ],
        sg: [
          {
            required: true,
            message: "请选择身高",
            trigger: ["blur", "change"],
          },
        ],
        tz: [
          {
            required: true,
            message: "请选择体重",
            trigger: ["blur", "change"],
          },
        ],
        dyxl: [
          {
            required: true,
            message: "请选择学历",
            trigger: ["blur", "change"],
          },
        ],
        dyxlbyxx: [
          {
            required: true,
            message: "请输入毕业学校",
            trigger: ["blur", "change"],
          },
        ],
        dyxlbysj: [
          {
            required: true,
            message: "请选择毕业时间",
            trigger: ["blur", "change"],
          },
        ],
        
        xgzdw: [
          {
            required: true,
            message: "请输入现工作单位",
            trigger: ["blur", "change"],
          },
        ],
        zwhgw: [
          {
            required: true,
            message: "请输入现职务或岗位",
            trigger: ["blur", "change"],
          },
        ],
        mkjxgznx: [
          {
            required: true,
            message: "请选择煤矿井下工作年限",
            trigger: ["blur", "change"],
          },
        ],
        xggwzgjndj: [
          {
            required: true,
            message: "请选择相关岗位最高技能等级",
            trigger: ["blur", "change"],
          },
        ],
        gzpxxxjl: [
          {
            required: true,
            message: "请输入个人履历",
            trigger: ["blur", "change"],
          },
        ],
      },
      options: {
        genderList: share.get("xb"),
        nationList: share.get("mz"),
        politicsFaceList: share.get("zzmm"),
        educationList: [
            {key: '17', value: '研究生'},
            {key: '20', value: '大学本科'},
            {key: '30', value: '大学专科'},
            {key: '40', value: '中等专科'},
            {key: '61', value: '技工学校'},
            {key: '60', value: '高中'},
            {key: '70', value: '初中'},
            {key: '80', value: '小学'},
            {key: '98', value: '无'}
        ],
        slList: share.get("sl"),
        sgList: share.get("sg"),
        tzList: share.get("tz"),
        mkjxgznxList: share.get("mkjxgznx"),
        xggwzgjndjList: share.get("xggwzgjndj"),
      },
    };
  },
  watch: {
    formData: {
      handler: function (newValue) {
        this.handlePropsData(newValue);
      },
      immediate: true,
    },
    "form.sfzhm": function (newValue) {
      if (newValue.length == 18) {
        this.form.xb =
          parseInt(newValue.substr(16, 1)) % 2 == 1 ? "1" : "2"; //奇数男，偶数女
        this.form.csrq =
          newValue.substr(6, 4) +
          "-" +
          newValue.substr(10, 2) +
          "-" +
          newValue.substr(12, 2);
      }
    },
  },
  methods: {
    /**
     * 打印报名表
     */
    print() {
      let param = {
        zpbmid: this.form.zpbmid,
      };
      request
        .doPrintBmdjb(param)
        .then((res) => {
          console.log("success");
          console.log(res);
          let file = JSON.parse(window.atob(res.djb));
          console.log(window.atob(res.djb));
          console.log(file);
          let base64 =
            "data:application/vnd.ms-excel;base64," + file.fileBase64;
          let a = document.createElement("a");
          a.setAttribute("href", base64);
          a.setAttribute("download", "报名登记表." + file.fileType);
          a.setAttribute("target", "_blank");
          a.click();
        })
        .catch((err) => {
          console.log("error");
          console.log(err);
        });
    },
    /**
     * 提交保存修改
     */
    submitModification() {
      if (this.validate()) {
        let param = {
          ...this.getData(),
          yhid: this.$store.state.userInfo.yhid, //用户id
          zpbmid: this.form.zpbmid, //招聘报名id
          zpqsid: this.form.zpqsid, //招聘启事id
          zpgwid: this.form.gwid, //招聘岗位id
          jg: JSON.stringify(this.form.jg),
        };
        console.log('param>>>', param)
        request
          .modifyShhzpBmxx(param)
          .then((res) => {
            console.log("success");
            console.log(res);
            this.editing = false;
            this.$message({
              message: "修改成功",
              type: "success",
              showClose: true,
            });
          })
          .catch((err) => {
            console.log("error");
            console.log(err);
          });
      }
    },
    /**
     * 修改报名信息
     */
    modifyRegisInfo() {
      //如果当前是正在修改，则表示改为不可编辑，并将数据复原；否则，拷贝一份原数据，以便下次复原
      if (this.editing) {
        this.form = this.cloneForm;
      } else {
        // this.cloneForm = Object.assign({}, this.form);
        this.cloneForm = JSON.parse(JSON.stringify(this.form));
      }
      this.editing = !this.editing;
      this.showDetails = true;
    },
    /**
     * 删除报名信息
     */
    deleteRegisInfo() {
      this.$confirm("确认删除本条报名信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            zpbmid: this.form.zpbmid,
          };
          request
            .deleteBmxx(param)
            .then((res) => {
              this.$message({
                message: "删除成功",
                type: "success",
                showClose: true,
              });
              this.$emit("deleted");
              console.log("success");
              console.log(res);
            })
            .catch((err) => {
              console.log("error");
              console.log(err);
            });
        })
        .catch(() => {});
    },
    /**
     * 弹框表格某一行双击回填
     */
    tableRowDbclickBackfill(row) {
      console.log("77");
      this.form.gwmc = row.gwmc;
      this.form.zpdw = row.zpdw;
      this.form.gwid = row.zpgwid;
      this.zpgwLov.table = [];
      this.zpgwLov.show = false;
    },
    /**
     * 查询招聘岗位
     */
    queryZpgw() {
      let param = {
        zpqsid: this.form.zpqsid,
        gwmc: this.zpgwLov.gwmc,
      };
      request
        .queryZpgwInfo(param)
        .then((res) => {
          this.zpgwLov.table = res.vds;
          console.log("success");
          console.log(res);
        })
        .catch((err) => {
          console.log("error");
          console.log(err);
        });
    },
    /**
     * 打开岗位查询/选择模态框
     */
    openZpgwDialog() {
      this.zpgwLov.show = true;
    },
    /**
     * 显示或隐藏报名信息
     */
    showOrHide() {
      this.showDetails = !this.showDetails;
    },
    /**
     * 将props中传的数据中的日期格式化
     */
    formatPropsDateToFormDate(date) {
      //date要么未空，要么yyyyMMdd，要么yyyy-MM-dd
      if (/\d{8}/.test(date)) {
        return (
          date.substr(0, 4) + "-" + date.substr(4, 2) + "-" + date.substr(6, 2)
        );
      }
      return date;
    },
    /**
     * 处理props传递的数据
     */
    handlePropsData(newValue) {
      console.log('sfzFileSuccessList>>>', this.sfzFileSuccessList);
      this.form.zpqsbt = newValue.zpqsbt; //招聘启事标题
      this.form.zpqsid = newValue.zpqsid; //招聘启事id
      this.form.zpdw = newValue.zpdw; //招聘单位
      this.form.gwmc = newValue.gwmc; //岗位名称
      this.form.gwid = newValue.zpgwid; //岗位名称
      this.form.zpbmid = newValue.zpbmid; //招聘报名id
      
      this.form.sfzhm = newValue.yxzjhm;
      this.form.xm = newValue.xm; //姓名
      this.form.xb = newValue.xb; //性别
      this.form.mz = newValue.mz; //民族
      this.form.zzmm = newValue.zzmm; //政治面貌
      this.form.csrq = this.formatPropsDateToFormDate(newValue.csrq); //出生日期
      try {
          this.form.jg = JSON.parse(newValue.jg); //籍贯
      } catch (error) {
          this.form.jg = newValue.jg;
      }
      this.form.jtzz = newValue.jtzz; //家庭住址
      this.form.sjhm = newValue.sjhm; //手机号码
      this.form.sl = newValue.sl; //视力
      this.form.sg = newValue.sg; //身高
      this.form.tz = newValue.tz; //体重

      this.form.dyxl = newValue.dyxl; //第一学历
      this.form.dyxlbyxx = newValue.dyxlbyxx; //毕业学校
      this.form.dyxlzy = newValue.dyxlzy; //所学专业
      this.form.dyxlbysj = this.formatPropsDateToFormDate(newValue.dyxlbysj); //毕业时间
      this.form.cjgzsj = this.formatPropsDateToFormDate(newValue.cjgzsj);//参加工作时间
      this.form.xgzdw = newValue.xgzdw; //现工作单位
      this.form.zwhgw = newValue.zwhgw; //现职务或岗位
      this.form.mkjxgznx = newValue.mkjxgznx; //煤矿井下工作年限
      this.form.xggwzgjndj = newValue.xggwzgjndj; //相关岗位最高技能等级
      this.form.xggwczzgz = newValue.xggwczzgz; //相关岗位操作资格证
      this.form.gzpxxxjl = newValue.gzpxxxjl; //个人履历

      this.form.bz = newValue.bz; //备注
      this.sfzFileSuccessList = newValue.ds_bmxx_fjxx
      .filter((ele) => ele.bmdbh === 'sfz_shhzp')
      .map(item => ({
        uid: item.fjxxid, // 使用附件信息ID作为唯一标识
        name: item.fjmc || '身份证附件', // 文件名
        raw: {
          name: item.fjmc || '身份证附件'
        },
        fjxxid: item.fjxxid, // 附件信息ID
        status: 'success' // 标记为上传成功状态
      }));
      // 毕业证附件处理
      this.byzFileSuccessList = newValue.ds_bmxx_fjxx
        .filter((ele) => ele.bmdbh === 'byz_shhzp')
        .map(item => ({
          uid: item.fjxxid,
          name: item.fjmc || '毕业证附件',
          raw: {
            name: item.fjmc || '毕业证附件'
          },
          fjxxid: item.fjxxid,
          status: 'success'
        }));

      this.gwzgzFileSuccessList = newValue.ds_bmxx_fjxx
      .filter((ele) => ele.bmdbh === 'gwzgz_shhzp')
      .map(item => ({
        uid: item.fjxxid,
        name: item.fjmc || '技能证书附件',
        raw: {
          name: item.fjmc || '技能证书附件'
        },
        fjxxid: item.fjxxid,
        status: 'success'
      }));
      
      console.log('sfzFileSuccessList>>>', this.sfzFileSuccessList);
    },
    /**
     * 获取校验后的数据
     */
    getData() {
      let data = {
        ...this.form,
        sfzFileList: JSON.stringify(this.sfzFileSuccessList),
        byzFileList: JSON.stringify(this.byzFileSuccessList),
        gwzgzFileList: JSON.stringify(this.gwzgzFileSuccessList),
      };
      return data;
    },
    /**
     * 校验数据是否都已填写
     */
    validate() {
      let validated = false;
      this.$refs.form.validate((valid) => {
        if (valid) {
          validated = true;
        } else {
          validated = false;
        }
      });
      //检查是否已上传身份证
      if (this.sfzFileSuccessList.length === 0) {
          this.$message.error("请上传身份证附件！");
          validated = false;
      }
      //检查是否已上传身份证
      if (this.byzFileSuccessList.length === 0) {
          this.$message.error("请上传毕业证附件！");
          validated = false;
      }
      //检查是否上传岗位资格证
      if (this.gwzgzFileSuccessList.length === 0) {
          this.$message.error("请上传毕业证附件！");
          validated = false;
      }
      return validated;
    },
    /**
     * 附件删除
     */
    deleteFile(index, type) {
      if(type == "1"){
          this.sfzFileSuccessList.splice(index, 1);
      } else if(type == "2") {
          this.byzFileSuccessList.splice(index, 1);
      } else if(type == "3") {
          this.gwzgzFileSuccessList.splice(index, 1);
      }
    },
    /**
     * 附件上传
     */
    setBMISection(type) {
      while (this.fileList.length > 0) {
          let fileData = new FormData();
          let item = this.fileList.shift();
          
          fileData.append("uploadfile", item.raw);
          fileData.append("filename", encodeURI(item.raw.name));
          fileData.append("fjlylx", "4");
          if (type == "1") {
              fileData.append("bmdbh", "sfz_shhzp");
              fileData.append("bmdmc", encodeURI("身份证"));
          }
          if (type == "2") {
              fileData.append("bmdbh", "byz_shhzp");
              fileData.append("bmdmc", encodeURI("毕业证"));
          }
          if (type == "3") {
              fileData.append("bmdbh", "gwzgz_shhzp");
              fileData.append("bmdmc", encodeURI("应聘岗位相关技能等级证或岗位资格证"));
          }
          
          request
              .setBMISection(fileData)
              .then((res) => {
                  console.log(res);
                  item.fjxxid = res.fjxxid;

                  if(type == "1"){
                      this.sfzFileSuccessList.push(item);
                  } else if(type == "2"){
                      this.byzFileSuccessList.push(item);
                  } else if(type == "3"){
                      this.gwzgzFileSuccessList.push(item);
                  }
              })
              .catch((err) => {
                  console.log(err);
                  // this.$message({
                  //   // message: err,
                  //   message: "文件  " + item.raw.name + "  上传失败! " + err,
                  //   type: "error"
                  // });
                  if(type == "1"){
                      this.qzjlFileFailList.push(item);
                  } else if(type == "2"){
                      this.cjbFileFailList.push(item);
                  } else if(type == "3"){
                      this.jytjbFileFailList.push(item);
                  }
              });
      }
  },
  /**
   * 附件上传文件添加回调方法
   */
  sfzUploadChange(file, fileList) {
      console.log('sfzUploadChange>>>')
      if(this.sfzFileSuccessList.length > 0){
          fileList.shift();
          this.$message.error("请删除已上传文件后再上传新文件！");
          return;
      }

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
          this.$message.error("上传附件大小不能超过2MB!");
          return;
      }
      console.log('>>>:qzjlUploadChange');
      this.fileList = fileList;
      this.setBMISection("1");
  },
  byzUploadChange(file, fileList) {
      console.log('>>>:byzUploadChange', fileList);
      if(this.byzFileSuccessList.length > 5){
          fileList.shift();
          this.$message.error("请删除已上传文件后再上传新文件！");
          return;
      }

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
          this.$message.error("上传附件大小不能超过2MB!");
          return;
      }
      console.log('>>>:cjbUploadChange');
      this.fileList = fileList;
      this.setBMISection("2");
  },
  gwzgzUploadChange(file, fileList) {
      if(this.gwzgzFileSuccessList.length > 0){
          fileList.shift();
          this.$message.error("请删除已上传文件后再上传新文件！");
          return;
      }

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
          this.$message.error("上传附件大小不能超过2MB!");
          return;
      }
      console.log('>>>:jytjbUploadChange');
      this.fileList = fileList;
      this.setBMISection("3");
  },
  },
};
</script>

<style lang="scss" scoped>
.input-tip {
    color: #f70808;
    font-size: 12px;
    margin-top: 5px;
}
.baseinfo-image {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;
  .image {
    margin: 10px;
    padding: 20px;
    width: 150px;
    height: 180px;
  }
}
.regisInfo {
  margin: 20px 0 0 0;
  background-color: #f2f2f2;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    .title {
      font-weight: bold;
      margin-bottom: 20px;
    }
    .info {
      margin-bottom: 20px;
    }
  }
  .view {
    align-self: flex-end;
    color: #2a8ae0;
    &:hover {
      cursor: pointer;
    }
  }
  .right {
    color: #2a8ae0;
    span {
      margin: 0px 20px;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
.red {
  color: #f56c6c;
}
.show {
  display: block;
}
.hide {
  display: none;
}
.header {
  font-weight: bold;
  padding: 10px;
  padding-left: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modify {
  color: #2a8ae0;
  &:hover {
    cursor: pointer;
  }
}
.delete {
  color: #ff5858;
  &:hover {
    cursor: pointer;
  }
}
.attachments-section {
  margin-top: 20px;
  width: 100%;
  box-sizing: border-box;
  
  .el-row {
    width: 100%;
  }
  
  .upload-hint {
    color: red;
    margin-left: 5px;
    font-weight: normal;
    font-size: 13px;
  }
  
  .attachment-card {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    margin-bottom: 20px;
    background-color: #fafafa;
    
    .card-header {
      padding: 12px 15px;
      border-bottom: 1px solid #ebeef5;
      font-weight: bold;
      display: flex;
      align-items: center;
      
      i {
        margin-right: 8px;
        color: #409eff;
      }
      
      .required {
        color: red;
        margin-left: 4px;
      }
    }
    
    .card-body {
      padding: 15px;
      
      .upload-demo {
        margin-bottom: 10px;
      }
      
      .upload-message {
        color: #f56c6c;
        font-size: 12px;
      }
    }
  }
  
  .general-attachments {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    margin-top: 20px;
    background-color: #fbfbfb;
    
    .card-header {
      padding: 12px 15px;
      border-bottom: 1px solid #ebeef5;
      font-weight: bold;
      display: flex;
      align-items: center;
      
      i {
        margin-right: 8px;
        color: #409eff;
      }
    }
    
    .upload-area {
      padding: 15px;
    }
  }
  
  .file-list-container {
    padding: 0 15px 15px;
    
    .file-section {
      margin-top: 15px;
      
      .section-title {
        font-weight: bold;
        margin-bottom: 10px;
        padding-bottom: 5px;
        border-bottom: 1px solid #ebeef5;
      }
      
      .success-title {
        color: #67c23a;
      }
      
      .fail-title {
        color: #f56c6c;
      }
    }
  }
  
  .file-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 10px;
  }
  
  .file-item {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    background-color: white;
    
    i:first-child {
      color: #409eff;
      margin-right: 8px;
    }
    
    .file-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    
    .delete-icon {
      color: #f56c6c;
      cursor: pointer;
      margin-left: 8px;
      
      &:hover {
        opacity: 0.8;
      }
    }
  }
  
  .success-item {
    border-color: #d1edff;
    background-color: #ecf5ff;
  }
  
  .fail-item {
    border-color: #fde2e2;
    background-color: #fef0f0;
    
    .file-actions {
      display: flex;
      align-items: center;
      
      .retry-text {
        color: #409eff;
        cursor: pointer;
        margin-right: 8px;
        font-size: 12px;
        
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  
}
</style>
